import { AritoIcon, IconActionButtonV2, LabelActionButtonV2 } from '@/components/custom/erp';

interface DetailToolbarProps {
  hasReceipt: boolean;
  loading: boolean;
  onRefresh: () => void;
}

export const DetailToolbar = ({ hasReceipt, loading, onRefresh }: DetailToolbarProps) => (
  <div className='flex items-center gap-0.5'>
    <LabelActionButtonV2 disabled className='text-[#006aa6]'>
      <AritoIcon icon={294} />
      Lưu phân bổ
    </LabelActionButtonV2>
    <LabelActionButtonV2 disabled className='text-[#006aa6]'>
      <AritoIcon icon={8} />
      Xóa phân bổ
    </LabelActionButtonV2>
    <IconActionButtonV2
      title='Làm mới'
      icon={15}
      onClick={onRefresh}
      disabled={!hasReceipt || loading}
      className='text-[#006aa6]'
    />
    <IconActionButtonV2 title='Cố định cột' icon={16} disabled className='text-[#006aa6]' />
  </div>
);

export default DetailToolbar;
